import React, { useEffect, useState } from 'react';

import useClassifications from '../../../hooks/useClassifications'

import SingleSelect from './SingleSelect'

const Classification = ({
    value,
    isNew,
    setClassification = () => {},
    setUseClassification = () => {},
    required,
    disabled,
    enabled = true,
}) => {
    const {
        classifications
    } = useClassifications()

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')

    useEffect(() => {
        const defaultClassification = isNew
            ? classifications.find(elem => elem.is_default === true)
            : null

        if (!value && defaultClassification) {
            setClassification(defaultClassification)
        }
    }, [value])

    useEffect(() => {
        const classification = classifications.find(elem => elem.id === value)
        if (classification) {
            setName(classification.name)
            setDescription(classification.description)
        }
    }, [value, classifications])

    // If disabled, the field should not be required in parent
    useEffect(() => {
        const use = enabled && classifications.filter(option => !option.is_archived).length > 0 && !disabled
        setUseClassification(use)
    }, [enabled, disabled, classifications])
    
    const handleChange = (value) => {
        setName(value.name)
        setDescription(value.description)
        setClassification(value)
    }

    if (!enabled || classifications.length === 0 ) {
        return null
    }

    if( disabled ) {
        return (
            <div className="form-group">
                <label className="col-sm-2 control-label">
                    Classification
                </label>
                <div className="col-sm-8">
                    <input className="form-control" type="text" value={name} disabled={true} />
                    <span className="help-block m-b-none m-t-none">
                        <small className="form-info-text" > {description} </small>
                    </span>
                </div>
            </div>
        )
    }
    
    return (
        <div className="form-group">
            <label className={`col-sm-2 control-label ${required ? 'required' : ''}`}>
                Classification
            </label>
            <div className="col-sm-8">
                <SingleSelect
                    name="classification_id"
                    value={value}
                    options={classifications.filter(option => disabled || !option.is_archived )}
                    onChange={(event) => handleChange(event)}
                    disabled={disabled}
                />
                <span className="help-block m-b-none m-t-none">
                    <small className="form-info-text">{description}</small>
                </span>
            </div>
        </div>
    )
}

export default Classification
